// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"2b5a65f6","416":"cb615c7f","706":"a43def54","730":"c742c4bd","919":"d78e3062","976":"e570ebe7"}[chunkId] + ".chunk.css";
};